import {
  USER_CHANGE_PASSWORD_REQUEST,
  USER_CHANGE_PASSWORD_SUCCESS,
  USER_CHANGE_PASSWORD_FAILURE,
} from "../Actions/Actions";

const initialState = {
  isLoading: false,
  success: null,
  error: null,
};

const changePasswordReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case USER_CHANGE_PASSWORD_REQUEST:
      return { ...state, isLoading: true, error: null, success: null };
    case USER_CHANGE_PASSWORD_SUCCESS:
      return { ...state, isLoading: false, success: payload, error: null };
    case USER_CHANGE_PASSWORD_FAILURE:
      return { ...state, isLoading: false, error: payload, success: null };
    default:
      return state;
  }
};

export default changePasswordReducer;